import React from "react";

import { fetchAddressSuggestions } from "../uber/fetchAddressSuggestions";
import { resolveDeepestRequestZone } from "../uber/fetchRequestZones";
import { pointInPolygon } from "../../utils/geom";
import { stripCountrySuffix } from "./formatAddress";
import TurfDropoffMapModalBase from "./TurfDropoffMapModalBase";

// same address suggestion source used by UberSiteCrewModal's pickup/dropoff/stop fields.
// `options.center` (TurfDropoffMapModalBase's per-canvasser search center) geobiases
// the results via Uber's own latitude/longitude params. Also filter
// client-side to a turf boundary passed in via `options.boundary` (a convex-hull ring),
// falling back to the unfiltered list if that leaves nothing. Nothing currently passes
// `boundary` -- left in place in case per-crew (rather than per-seat) search comes back.
const searchAddresses = (query, options = {}) => {
  const { center, boundary } = options;

  return fetchAddressSuggestions(query, center).then((suggestions) => {
    const results = suggestions
      .filter((s) => s.latitude && s.longitude)
      .map((s, idx) => ({
        key: s.id || `${idx}-${s.full_address}`,
        primary: s.name || s.full_address,
        secondary: s.name ? s.address_line_2 : null,
        fullAddress: stripCountrySuffix(s.full_address) || s.name,
        lat: s.latitude,
        lon: s.longitude,
      }));

    if (!boundary) return results;

    const withinBoundary = results.filter((r) =>
      pointInPolygon([r.lon, r.lat], boundary)
    );

    return withinBoundary.length ? withinBoundary : results;
  });
};

// Best-effort refinement of a resolved dropoff/pickup point down to Uber's most
// specific request zone (e.g. a particular airport curb) before it's saved --
// see resolveDeepestRequestZone for how "most specific" is walked to fully
// automatically, with no picker UI. Locations outside any Uber-defined zone
// (the vast majority of ordinary residential dropoffs) come back unchanged.
const refineAddress = async ({ lat, lon, fullAddress }) => {
  const refined = await resolveDeepestRequestZone(lat, lon);
  if (!refined.label) return { lat, lon, fullAddress };

  return {
    lat: refined.lat,
    lon: refined.lon,
    fullAddress: `${fullAddress} - ${refined.label}`,
  };
};

const TurfDropoffMapModalUber = (props) => (
  <TurfDropoffMapModalBase
    {...props}
    searchAddresses={searchAddresses}
    refineAddress={refineAddress}
  />
);

export default TurfDropoffMapModalUber;
